// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lQdGy","type":"styles_type__3KBdk","choices":"styles_choices__1KUkm"};